<loading :active="this.allPageLoading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="true"
        :color="'#fff'"
        :background-color="'#000'"
        :opacity="'0.8'"
        :loader=" dots">
</loading>
<template>
  <div class="rounded-xl shadow border p-4 space-y-6 mt-6">
    <div class="text-gray-800">
     {{lang['components']['LinkAccount']['Account']['advertise_account_text']}}：{{ accountInfo.info.name }}（{{ accountInfo.info.id }}）
     <button type="button" class="text-xs text-blue-light" @click="tiktokRemoveAd(accountInfo.info.id, accountInfo.info.name)">{{lang['components']['LinkAccount']['Account']['adaccount_delete_button_text']}}</button>
    </div>
    <div class="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4">
      <Card
        v-for="(item, index) in accountInfo.fanPageList"
        :key="index"
        v-model:adaccountId="accountInfo.info.id"
        v-model:id="item.id"
        v-model:title="item.title"
        v-model:imgSrc="item.imgSrc"
        v-model:checked="item.checked"
        v-bind:lang="lang"
      />
      <AddCard v-bind:lang="lang" v-model:connectId="accountInfoData.info.id" v-bind:allSelected="accountInfo.allSelected" />
    </div>
  </div>
</template>

<script>
import Card from './Card.vue'
import AddCard from './AddCard.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'Account',
  components: {
    Card,
    AddCard,
    Swal,
    Loading,
  },
  props: {
    lang: {
      type: Object
    },
    accountInfo: {
      type: Object,
      default: () => ({
        info: {
          name: null,
          id: null,
        },
        fanPageList: [
          { id: null, title: null, imgSrc: null, checked: false}
        ],
        allSelected: false
      })
    }
  },
  data() {
    return {
      allPageLoading: false
    };
  },
  methods: {
    tiktokRemoveAd(id, name){
      //console.log('tiktok tiktokRemoveAd');
      //console.log('id');
      // console.log(id);
      // console.log('name');
      // console.log(name);

      let member_hash = this.$route.params.id

      axios
        .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: 'member',
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  // window.location.href = "https://private.autoturn.net/"+member_hash;
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  // window.location.href = "https://private.autoturn.net/"+member_hash;
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                // if (result.isConfirmed) {
                //   // Swal.fire('Saved!', '', 'success')
                //   this.allPageLoading = true
                //   window.location.href = "http://localhost:8080/"+member_hash;
                // } else if (result.isDenied) {
                //   // Swal.fire('Changes are not saved', '', 'info')
                //   this.allPageLoading = true
                //   window.location.href = "http://localhost:8080/"+member_hash;
                // }

                // if (result.dismiss === Swal.DismissReason.timer) {
                //   this.allPageLoading = true
                //   window.location.href = "http://localhost:8080/"+member_hash;
                // }
              })
            } else {
              Swal.fire(
                        this.lang['components']['LinkAccount']['Account']['removeAd']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              if (result.isConfirmed) {
                Swal.fire({
                  title: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_title_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_title_b'],
                  html: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_html_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_html_b']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['is_confirmed_swal_html_c'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['yes_button'],
                  cancelButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    axios
                      .post('https://www.autoturn.net/api/tiktok/data/tiktok_advertiser_remove_ad.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        advertiser: id
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        // if(response.data.status == 'success'){
                          // Swal.fire(
                          //   "刪除「"+name+"」廣告帳戶連結",
                          //   response.data.info,
                          //   response.data.status
                          // )
                          Swal.fire({
                            icon: response.data.status,
                            title: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['fan_adaccount_remove_ad']['swal_title_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['fan_adaccount_remove_ad']['swal_title_b'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['warning']['confirm_button'],
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')
                              // this.allPageLoading = true;
                              // window.location.reload();
                              var todayForm = new Date();
                              var yearForm = todayForm.getFullYear();
                              var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              todayForm = yearForm + monthForm + dateForm + timeForm;

                              this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                              // this.allPageLoading = true;
                              // window.location.reload();
                              var todayForm = new Date();
                              var yearForm = todayForm.getFullYear();
                              var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              todayForm = yearForm + monthForm + dateForm + timeForm;

                              this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                            }
                          })
                        // }
                      });
                  }
                })
              }
            });
          }

          if(caResponse.data.status == 'success'){
            Swal.fire({
              title: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_title_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_title_b'],
              html: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_html_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_html_b']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['success']['swal_html_c'],
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['yes_button'],
              cancelButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['no_button'],
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .post('https://www.autoturn.net/api/tiktok/data/tiktok_advertiser_remove_ad.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    advertiser: id
                  }))
                  .then((response) => {
                    // console.log(response.data);
                    // if(response.data.status == 'success'){
                      // Swal.fire(
                      //   "刪除「"+name+"」廣告帳戶連結",
                      //   response.data.info,
                      //   response.data.status
                      // )
                      Swal.fire({
                        icon: response.data.status,
                        title: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['fan_adaccount_remove_ad']['swal_title_a']+name+this.lang['components']['LinkAccount']['Account']['removeAd']['success']['fan_adaccount_remove_ad']['swal_title_b'],
                        text: response.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['success']['fan_adaccount_remove_ad']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          // this.allPageLoading = true;
                          // window.location.reload();
                          var todayForm = new Date();
                          var yearForm = todayForm.getFullYear();
                          var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          todayForm = yearForm + monthForm + dateForm + timeForm;

                          this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          // this.allPageLoading = true;
                          // window.location.reload();
                          var todayForm = new Date();
                          var yearForm = todayForm.getFullYear();
                          var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          todayForm = yearForm + monthForm + dateForm + timeForm;

                          this.$emit('childTiktokConnectAccount', 'true_'+todayForm);
                        }
                      })
                    // }
                  });
              }
            })
          }

          if(caResponse.data.status == 'login'){
            Swal.fire({
              icon: 'error',
              title: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['swal_title'],
              text: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['LinkAccount']['Account']['removeAd']['login']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              }
            })
          }
        });
    }
  },
  computed: {
    accountInfoData: {
      get: function () {
        return this.accountInfo
      },
      set: function (value) {
        this.$emit('update:accountInfoData', value)
      },
    }
  }
}
</script>

<style scoped>

</style>